import { positionSpotlight, removeSpotlight } from "./spotlight-utils"

const SPOTLIGHT_ID = "tour-spotlight"

export default {
  mounted() {
    this.position()
    this._onResize = () => this.position()
    window.addEventListener("resize", this._onResize)
  },
  updated() {
    this.position()
  },
  destroyed() {
    window.removeEventListener("resize", this._onResize)
    removeSpotlight(SPOTLIGHT_ID)
  },
  position() {
    positionSpotlight(this.el, {
      cardId: "tour-card",
      backdropId: "tour-backdrop",
      spotlightId: SPOTLIGHT_ID,
      defaultOpacity: 0.55,
      pad: 10,
      gap: 16,
      borderRadius: "12px"
    })
  }
}
